import service from "@/store/services/items-service";

const state = {
  list: {},
  item: {},
  meta: {},
  url: null,
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, item) => {
    state.item = item;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service
      .get(params)
      .then((item) => {
        if (item.hasOwnProperty("data") && item.data.error) {
          commit("SET_ERROR_BIT", true, { root: true });
          commit(
            "SET_ERROR_INFO",
            "<br>" +
              "Server responded with error = True <br> errorCode: " +
              item.data.errorCode,
            { root: true }
          );
        }
        commit("SET_RESOURCE", item);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },

  add({ commit, dispatch }, params) {
    return service
      .add(params)
      .then((item) => {
        if (item.hasOwnProperty("data") && item.data.error) {
          commit("SET_ERROR_BIT", true, { root: true });
          commit(
            "SET_ERROR_INFO",
            "<br>" +
              "Server responded with error = True <br> errorCode: " +
              item.data.errorCode,
            { root: true }
          );
        }
        commit("SET_RESOURCE", item);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },

  update({ commit, dispatch }, params) {
    return service
      .update(params)
      .then((item) => {
        if (item.hasOwnProperty("data") && item.data.error) {
          commit("SET_ERROR_BIT", true, { root: true });
          commit(
            "SET_ERROR_INFO",
            "<br>" +
              "Server responded with error = True <br> errorCode: " +
              item.data.errorCode,
            { root: true }
          );
        }
        commit("SET_RESOURCE", item);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },

  upload({ commit, dispatch }, { item, image }) {
    return service
      .upload(item, image)
      .then((url) => {
        if (url.hasOwnProperty("data") && url.data.error) {
          commit("SET_ERROR_BIT", true, { root: true });
          commit(
            "SET_ERROR_INFO",
            "<br>" +
              "Server responded with error = True <br> errorCode: " +
              url.data.errorCode,
            { root: true }
          );
        }
        commit("SET_URL", url);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  item: (state) => state.item,
  url: (state) => state.url,
};

const items = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default items;
